import React, { useEffect, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import vAdminformat from "../../adminFormat";
import { Link } from "react-router-dom";
import { useInvoicePrinter } from "../PrintInvoices";
import Swal from "sweetalert2";


const server_backend = config.API_URL;

const InvoiceViews = ({ InvoiceID, CloseViewInvoices, onRenderComplete }) => {
    //console.log({ invoiceID: InvoiceID })
    const [Invoice, setInvoice] = useState({
        jobs: []
    });

    const [formData, setFormData] = useState({
        accessToken: localStorage.getItem('xeroAccessToken') || '',
        tenantId: localStorage.getItem('xeroTenantId') || '',
    });

    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);
    const [emailData, setEmailData] = useState({
        primaryEmail: '',
        additionalEmail: ''
    });

    const [details, setDetails] = useState([]);
    const [ammountSummary, setAmmountSummary] = useState([]);


    useEffect(() => {
        const getCurrentFile = async () => {
            try {
                const response = await axios.get(`${server_backend}/Invoices/select?id=${InvoiceID}`, headers);
                //console.log({ HITHERE: response.data });
                if (response.data.RES_CODE === "00") {
                    const data = (response.data.RES_RESULT);
                    setEmailData({ ...emailData, primaryEmail: data.email });
                    setInvoice(data);
                    setAmmountSummary(data.details);
                    setDetails(reverseTransformItems(data.details));
                }
            } catch (error) {
                console.log(error)
            } finally {
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentFile();
    }, []);


    const downloadInvoice = () => {
        const element = document.getElementById('invoice-container');

        const options = {
            margin: 0,
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save();
    };

    const { handlePrint } = useInvoicePrinter('invoice-container');

    const showModalSendEmail = () => {
        setSendEmail(true);
    }

    const closeModalSendEmail = () => {
        setSendEmail(false);
    }

    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        setEmailData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const sendEmailData = async () => {
        try {
            const response = await axios.post('http://your-backend-url/api/send-email', emailData);
            console.log('Email sent successfully:', response.data);
            setSendEmail(false);
        } catch (error) {
            console.error('Error sending email:', error.response?.data || error.message);
        }
    };

    const reverseTransformItems = (transformedItems) => {
        const groupedItems = {};
 
        transformedItems.forEach((item) => {
            const { Item_Name, pto_id, roducts_name, descript, qty, price, discount } = item;

            if (!groupedItems[Item_Name]) {
                groupedItems[Item_Name] = {
                    ordj_name: Item_Name,
                    ordj_qty: 0, 
                    ordj_price: 0,
                    ordj_discount: 0, 
                    ordj_description: descript,
                    products: [] 
                };
            }

            groupedItems[Item_Name].ordj_qty += qty;
            groupedItems[Item_Name].ordj_price += price;
            groupedItems[Item_Name].ordj_discount += discount;

            if (pto_id !== 0) {
                groupedItems[Item_Name].products.push({
                    pto_ID: pto_id,
                    name: roducts_name,
                    qty: qty,
                    price: price,
                    discount: discount
                });
            }
        });

        return Object.values(groupedItems);
    };


    const calculateSubTotal = (items) => {
        return items.reduce((total, item) => {
            const qty = item.qty ? parseFloat(item.qty) : 0; 
            const price = item.price ? parseFloat(item.price) : 0; 
            const discount = item.discount ? parseFloat(item.discount) : 0;

            let itemTotal = ((qty * price) - discount);

            //console.log(`Item: ${item.productos}, qty: ${qty}, price: ${price}, subtotal del item: ${itemTotal}`);

            return total + itemTotal;
        }, 0);
    };

    const calculateDiscountTotal = (items) => {
        return items.reduce((total, item) => {
            const qty = item.qty ? parseFloat(item.qty) : 0;
            const price = item.price ? parseFloat(item.price) : 0;
            const discount = item.discount ? parseFloat(item.discount) : 0;

            let itemDiscount = (qty * price) - discount;

            //console.log(`Item: ${item.productos}, qty: ${qty}, price: ${price}, descuento del item: ${itemDiscount}`);

            return itemDiscount;
        }, 0);
    };


    const calculateTotalAmount = (subTotal, tax, discount) => {
        return subTotal + tax - discount;
    };


    const calculateTax = (subTotal) => {
        return subTotal * 0.20;
    };

    const transformItems = (items) => {
        let transformedItems = [];

        items.forEach(item => {
            const { ordj_ID, ordj_name, ordj_qty, ordj_price, ordj_description, ordj_discount, products } = item;

            if (ordj_name) {
                transformedItems.push({
                    id: Invoice.ord_ID ? Invoice.ord_ID : null,
                    ordj_id: ordj_ID || null,
                    pto_id: 0,
                    productos: ordj_name,  
                    descript: ordj_description || "nombre del stl", 
                    qty: ordj_qty || 1,
                    price: parseFloat(ordj_price) || 0,  
                    discount: parseFloat(ordj_discount) || 0 
                });
            }


            if (Array.isArray(products) && products.length > 0) {
                products.forEach(product => {
                    transformedItems.push({
                        id: Invoice.ord_ID ? Invoice.ord_ID : 0,
                        ordj_id: ordj_ID || 0,
                        pto_id: product.pto_ID || 0,
                        productos: product.name || "nombre del stl",
                        descript: ordj_description || "nombre del stl",  
                        qty: product.qty || 0, 
                        price: parseFloat(product.price) || 0, 
                        discount: parseFloat(product.discount) || 0 
                    });
                });
            }
        });

        return transformedItems;
    };

    const createInvoiceWithContact = async () => {
        try {
            const tenantId = formData.tenantId; 
            let contact = null;

            // Paso 1: Buscar contacto
            try {
                const contactResponse = await axios.post('http://localhost:5000/api/xero/contact', {
                    tenantId,
                    searchName: Invoice.cust_ID, 
                });
                contact = contactResponse.data;
                setFormData({ ...formData, contact_ID: contact.contactID });
            } catch (error) {
                if (error.response && error.response.status !== 404) {
                    throw error;
                }
            }

            if (!contact) {
                const createResponse = await axios.post('http://localhost:5000/api/xero/createContact', {
                    tenantId,
                    contactData: {
                        name: Invoice.fullname,
                        emailAddress: Invoice.email,
                        accountNumber: Invoice.cust_ID,
                        phones: [
                            {
                                phoneType: 'MOBILE',
                                phoneNumber: Invoice.phone,
                            },
                        ],
                    },
                });
                contact = createResponse.data;
                setFormData({ ...formData, contact_ID: contact.contactID });
            }

            return contact.contactID; 
        } catch (error) {
            console.error('Error al verificar o crear el contacto:', error);
            throw error; 
        }
    };

    const createInvoiceXero = async () => {
        try {
          
            // const contactID = await createInvoiceWithContact(customerData);
            // console.log({ contactID: contactID })

            const lineItems = Invoice.details.map(item => ({
                ItemCode: "ITEM001",
                description: item.comment,               
                quantity: item.qty,                     
                unitAmount: item.total,                 
                accountCode: '200',
                TaxType: "TAX001",             
                unitTaxAmount: (item.total * 0.20) / item.qty,  
                discountRate: item.discount 
            }));

            const currentDate = new Date();
            const currentDateInMillis = currentDate.getTime();

            const invoiceData = {
                "type": "ACCREC",                     
                "contact": {
                    "name": `${Invoice.fullname}`,    
                    "accountNumber": `${Invoice.fullname}`,  
                    "emailAddress": `${Invoice.email}`
                },
                "CurrencyCode": "GBP", 
                "date": `/Date(${currentDateInMillis}+0000)/`, 
                "dueDate": `/Date(${currentDateInMillis + 7 * 24 * 60 * 60 * 1000}+0000)/`,
                "dateString": currentDate.toISOString(),
                "dueDateString": new Date(currentDate.setDate(currentDate.getDate() + 7)).toISOString(),
                "lineAmountTypes": "Exclusive",                           
                "Status": "AUTHORISED",
                "lineItems": lineItems                                   
            };

            const response = await axios.post(`${server_backend}/api/xero/invoice`, {
                invoiceData
              
            }, headers);
            console.log(response.data);

            Swal.fire({
                icon: 'success',
                title: 'Invoice sent successfully',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (error) {
            console.error('Error al crear la factura:', error);
            Swal.fire({
                icon: 'error',
                title: 'An unexpected error has occurred, please try again later.',
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };




    return (

        <div className="container-fluid">
            {/* start page title */}
            <div className="card-header">
                <div className="d-flex justify-content-end mt-3 p-2">
                    <div className="flex-grow-1">
                        <div className="hstack text-nowrap gap-2">
                            <button type="button" className="btn btn-danger" onClick={CloseViewInvoices} data-bs-toggle="tooltip" data-bs-placement="top" title="Go Back">
                                <i className="ri-arrow-go-back-line"></i>
                            </button>

                            {/*  <button type="button" className="btn btn-warning" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={ShowModalUpdate}>
                                <i className="ri-pencil-fill align-bottom"></i>
                            </button> */}

                            <Link to="/create-Order" className="btn btn-light" data-bs-toggle="tooltip" data-bs-placement="top" title="New">
                                <i class="ri-file-add-line"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="flex-shrink-0">
                        <div className="hstack text-nowrap gap-2">

                            <button type="button" className="btn btn-secondary d-flex align-items-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Start Job" onClick={createInvoiceXero}>
                                <span className="icon-container" style={{ marginRight: "5px" }}>
                                    <i className="ri-stackshare-line"></i>
                                </span>
                                <span>Sent to Xero</span>
                            </button>

                            <Link className="btn btn-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={showModalSendEmail}>
                                <i className="ri-mail-send-line"></i>
                            </Link>


                            <Link className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={handlePrint}>
                                <i className="ri-printer-line"></i>
                            </Link>

                            <Link className="btn btn-info" data-bs-toggle="tooltip" data-bs-placement="top" title="Download" onClick={downloadInvoice}>
                                <i className="ri-download-2-line"></i>
                            </Link>

                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-xxl-9">
                    <div className="card" >
                        <div id="invoice-container">
                            <div className="card-header bInvoice-bottom-dashed p-4">
                                <div className="d-sm-flex">
                                    <div className="flex-grow-1">
                                        <img src="assets/images/dbclogo.jpg" alt="" height="40" />
                                        <div className="mt-sm-5 mt-4">
                                            <h6 className="text-muted text-uppercase fw-semibold">Address</h6>
                                            <p className="text-muted mb-1" id="address-details">Design Build Cast Ltd
                                                Unit 3.01,</p>
                                            <p className="text-muted mb-0">The Goldsmiths Centre,</p>
                                            <p className="text-muted mb-0">42 Britton Street,
                                                London EC1M 5AD</p>
                                        </div>
                                    </div>
                                    <div className="flex-shrink-0 mt-sm-0 mt-3">
                                        <h6><span className="text-muted fw-normal">Email:</span> <span id="email">enquiries@designbuildcast.co.uk</span></h6>
                                        <h6><span className="text-muted fw-normal">Website:</span> <a href="https://enquiries@designbuildcast.co.uk/" className="link-primary" target="_blank" id="website">designbuildcast.co.uk</a></h6>
                                        <h6 className="mb-0"><span className="text-muted fw-normal">Contact No: </span><span id="contact-no">0207 608 2228
                                        </span></h6>
                                    </div>
                                </div>
                            </div>
                            {/*end card-header*/}
                            <div className="card-body p-4">
                                <div className="row g-3">
                                    <div className="col-lg-3 col-6">
                                        <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                                        <h5 className="fs-14 mb-0"><span id="invoice-no">{Invoice.inv_ID}</span></h5>
                                    </div>
                                    {/*end col*/}
                                    <div className="col-lg-3 col-6">
                                        <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                        <h6 className="fs-14 mb-0"><span id="invoice-date">{/* {formatDateString(Invoice.date_created)} */}</span></h6>
                                    </div>
                                    {/*end col*/}
                                    <div className="col-lg-3 col-6">
                                        <p className="text-muted mb-2 text-uppercase fw-semibold">Status</p>
                                        <span className={`${Invoice.est_ID === 4 ? "badge badge-soft-warning text-uppercase"
                                            : (
                                                Invoice.est_ID === 5 ? "badge badge-soft-success text-uppercase"
                                                    : (
                                                        Invoice.est_ID === 6 ? "badge badge-soft-danger text-uppercase" : (
                                                            Invoice.est_ID === 13 ? "badge badge-label bg-danger" : null
                                                        )
                                                    )
                                            )} text-uppercase`}>
                                            {Invoice.status_name}
                                        </span>
                                    </div>
                                    {/*end col*/}
                                    <div className="col-lg-3 col-6">
                                        <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                                        <h5 className="fs-14 mb-0"><span id="total-amount">{vAdminformat.FormatMoney(Invoice.total_summary)}</span></h5>
                                    </div>
                                    {/*end col*/}
                                </div>
                                {/*end row*/}
                            </div>
                            {/*end card-body*/}
                            <div className="card-body p-4 bInvoice-top bInvoice-top-dashed">
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <h6 className="text-muted text-uppercase fw-semibold mb-3">Customer Information</h6>
                                        <p className="text-muted mb-1" id="billing-name">{Invoice.fullname}</p>

                                        <p className="text-muted mb-1" id="billing-address-line-1">{Invoice.email}</p>
                                        <p className="text-muted mb-1"><span>Phones: </span><span id="billing-phone-no">{Invoice.phone} {Invoice.phone2 && (
                                            `/ ${Invoice.phone2}`
                                        )} </span></p>
                                        <p className="text-muted mb-1" id="billing-name">Customer ID:  <span > {Invoice.cust_ID}</span></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h6 className="text-muted text-uppercase fw-semibold mb-3">Customer Address</h6>

                                        <p className="text-muted mb-1" id="billing-address-line-1">{Invoice.address}</p>
                                        <p className="text-muted mb-1">{Invoice.city}, {Invoice.zipcode}</p>
                                        <p className="text-muted mb-1">{Invoice.country}</p>
                                    </div>
                                    {/*end col*/}


                                </div>
                                {/*end row*/}
                            </div>
                            {/*end card-body*/}
                            <div className="card-body p-2">
                                <div className="table-responsive">
                                    <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                        <thead>
                                            <tr className="table-secondary">
                                                <th scope="col">Item Name</th>
                                                <th scope="col">Product Details</th>
                                                <th scope="col">Quantity</th>
                                                <th scope="col">Unit Price</th>
                                                <th scope="col">Discount</th>
                                                <th scope="col" className="text-end">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody id="products-list">
                                            {details.length > 0 && details.map((item, itemIndex) => (
                                                <>
                                                    <tr key={itemIndex}>

                                                        <td>
                                                            <strong>
                                                                {item.ordj_name}
                                                            </strong>
                                                        </td>

                                                        <td>
                                                            {item.ordj_description}
                                                        </td>
                                                        <td>
                                                            <td className="text-center d-flex justify-content-center">
                                                                {item.ordj_qty}
                                                            </td>
                                                        </td>
                                                      
                                                        <td>
                                                            {vAdminformat.FormatMoney(item.ordj_price)}
                                                        </td>
                                                     
                                                        <td>
                                                            {vAdminformat.FormatMoney(item.ordj_discount)}
                                                        </td>
                                                     
                                                        <td className="text-end">
                                                            {vAdminformat.FormatMoney((item.ordj_qty * item.ordj_price) - item.ordj_discount)}
                                                        </td>

                                                    </tr>
                                                    {item.products.map((product, productIndex) => (
                                                        <tr key={productIndex}>
                                                            <td></td>
                                                            <td>{product.name}</td>
                                                            <td className="text-center d-flex justify-content-center">

                                                                {product.qty}

                                                            </td>
                                                            <td>
                                                                {vAdminformat.FormatMoney(product.price)}
                                                            </td>
                                                            <td>
                                                                {vAdminformat.FormatMoney(product.discount)}
                                                            </td>
                                                            <td className="text-end">
                                                                {vAdminformat.FormatMoney((product.qty * product.price) - product.discount)}
                                                            </td>

                                                        </tr>
                                                    ))}
                                                </>
                                            ))}

                                            <tr className="border-top border-top-dashed mt-2">
                                                <td colSpan="5"></td>
                                                <td colSpan="2" className="fw-medium p-0">
                                                    <table className="table table-borderless text-start table-nowrap align-middle mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <td>Sub Total</td>
                                                                <td className="text-end">
                                                                    {vAdminformat.FormatMoney(calculateSubTotal(ammountSummary))}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Estimated Tax (20%)</td>
                                                                <td className="text-end">
                                                                    {vAdminformat.FormatMoney(calculateTax(calculateSubTotal(ammountSummary)))}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Discount Total</td>
                                                                <td className="text-end">
                                                                    -{vAdminformat.FormatMoney(calculateDiscountTotal(ammountSummary))}
                                                                </td>
                                                            </tr>
                                                            <tr className="border-top border-top-dashed">
                                                                <th scope="row">Total Amount</th>
                                                                <td className="text-end">
                                                                    {vAdminformat.FormatMoney(calculateTotalAmount(
                                                                        calculateSubTotal(ammountSummary),
                                                                        calculateTax(calculateSubTotal(ammountSummary)),
                                                                        calculateDiscountTotal(ammountSummary)
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>


                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        {/*end card-body*/}
                    </div>
                    {/*end card*/}
                </div>
            </div>
            {/*end row*/}
            <div
                className={`modal fade ${sendEmail ? "show" : ""}`}
                style={{ display: sendEmail ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-sm" style={{ maxWidth: "500px" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="emailModalLabel">Send Email</h5>
                            </center>
                            <button type="button" className="btn-close" aria-label="Close" onClick={closeModalSendEmail}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Primary Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Primary Email"
                                    name="primaryEmail"
                                    value={emailData.primaryEmail}
                                    onChange={handleEmailChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Additional Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Additional Email"
                                    name="additionalEmail"
                                    value={emailData.additionalEmail}
                                    onChange={handleEmailChange}
                                />
                            </div>
                            <div className="d-flex justify-content-end">
                                <button type="button" className="btn btn-danger" style={{ marginRight: "5px" }} onClick={closeModalSendEmail}>
                                    Discard
                                </button>
                                <button type="button" className="btn btn-primary" onClick={sendEmailData}>
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}


export default InvoiceViews;